import { IconEnum } from './enum/IconEnum';

export enum IconsEnum {
    ADVICE = 'advice',
    ARTICLE = 'article',
    ARROW = 'arrow',
    ATTACHEMENT = 'attachement',
    BEACH = 'beach',
    BIB = 'bib',
    BOOKMARK_CHECKED = 'bookmarkChecked',
    BURGER = 'burger',
    BUS = 'bus',
    CALENDAR = 'calendar',
    CAMERA = 'camera',
    CHARITY_BIB = 'charityBib',
    CHECKBOX = 'checkbox',
    CHEVRON = 'chevron',
    CHEVRON_DOWN = 'chevronDown',
    CHEVRON_LEFT = 'chevronLeft',
    CHEVRON_RIGHT = 'chevronRight',
    CHEVRON_UNCONSTRAINED = 'chevronUnconstrained',
    CHEVRON_UP = 'chevronUp',
    CLOSE = 'close',
    CLIPBOARD = 'clipboard',
    COASTAL_PATH = 'coastalPath',
    DAY_TIME = 'dayTime',
    DESERT = 'desert',
    DISCOVER = 'discover',
    DONATION = 'donation',
    DOWN = 'down',
    DOWNLOAD = 'download',
    EVENT_CENTER = 'eventCenter',
    EXCITED = 'excited',
    EXCEL = 'excel',
    FINISH_INDEX = 'finishIndex',
    FINISH_WS = 'finishWs',
    FLAG = 'flag',
    LINEPLUS = 'linePlus',
    FOURPLUS = 'fourPlus',
    NINEPLUS = 'ninePlus',
    GLACIER = 'glacier',
    HAND_COINS = 'handCoins',
    HEART = 'heart',
    HELP = 'help',
    HIGH_ALTITUDE = 'highAltitude',
    HIKING_TRAIL = 'hikingTrail',
    HILL = 'hill',
    HOME = 'home',
    INFO = 'info',
    INTERVIEW = 'interview',
    INVOLVED = 'involved',
    JUNGLE = 'jungle',
    LEFT = 'left',
    LEGEND = 'legend',
    LIVE = 'live',
    LOCK = 'lock',
    LOGO_AD_BG = 'logoAdBg',
    LOGO_SIMPLIFIED = 'logoSimplified',
    LOGO_SIMPLIFIED_DARK = 'logoSimplifiedDark',
    LOGO_FINALS = 'logoFinals',
    LOGO_MAJOR = 'logoMajor',
    LOGOUT = 'logout',
    MAG = 'mag',
    MOBILITY = 'Mobility',
    MOUNTAIN = 'mountain',
    MY_ACHIEVEMENT = 'myAchievement',
    MY_DASHBOARD = 'myDashboard',
    MY_INFORMATION = 'myInformation',
    MY_REGISTRATION = 'myRegistration',
    MY_REWARDS = 'myRewards',
    MY_UTMB_POINTS = 'myUtmbPoints',
    MY_UTMB_POINTS_GENERIC = 'myUtmbPointsGeneric',
    NEXT = 'next',
    NIGHT_TIME = 'nightTime',
    NO = 'no',
    OTHER = 'other',
    PEN = 'pen',
    PIN = 'pin',
    PLUS_LOYALTY = 'plusLoyalty',
    QUOTE = 'quote',
    RACE = 'race',
    RACE_FLAG = 'raceFlag',
    RANDOM = 'random',
    REFUELING_STAND = 'refuelingStand',
    RIGHT = 'right',
    ROAD = 'road',
    RS = 'rs',
    RUNNER = 'runner',
    RUNNING_STONE = 'runningStone',
    RUNNING_STONES = 'runningStones',
    SEARCH = 'search',
    SHARE = 'share',
    SHOP = 'shop',
    SINGLE_TRACK = 'singleTrack',
    SMILEY_LAUGH = 'smileyLaugh',
    SMILEY_SHY = 'smileyShy',
    SMILEY_SURPRISED = 'smileySurprised',
    SOCIAL_DAILYMOTION = 'dailymotion',
    SOCIAL_FACEBOOK = 'facebook',
    SOCIAL_INSTAGRAM = 'instagram',
    SOCIAL_LINKEDIN = 'linkedin',
    SOCIAL_STRAVA = 'strava',
    SOCIAL_TIKTOK = 'tiktok',
    SOCIAL_TWITTER = 'twitter',
    SOCIAL_WECHAT = 'wechat',
    SOCIAL_X = 'socialX',
    SOCIAL_YOUTUBE = 'youtube',
    SPINNER = 'spinner',
    STAR = 'star',
    STAR_BORDER = 'starBorder',
    START_INDEX = 'startIndex',
    START_WS = 'startWs',
    STONE_EVENTS = 'stone_events',
    STONE_MAJORS = 'stone_majors',
    THUMB_UP = 'thumbUp',
    TICKET = 'ticket',
    TRAIN = 'train',
    TRASH = 'trash',
    TRASH_SECOND = 'trashSecond',
    TUNNEL = 'tunnel',
    UP = 'up',
    USER = 'user',
    UTMB_FINAL = 'utmbFinal',
    UTMB_GROUP = 'utmbGroup',
    UTMB_RUNNER = 'utmbRunner',
    VOLONTEER = 'VOLONTEER',
    WOODS = 'woods',
    WS_CATEGORIES = 'WS_CATEGORIES',
}

export interface IconsProps {
    variant: IconsEnum | IconEnum;
    color?: string;
    clss?: string;
    width?: number;
    height?: number;
}

export interface IconSvgProps {
    color?: string;
    clss?: string;
    width?: number;
    height?: number;
}
